/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_TitleInputs */

const en_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Event/Text`)
};

const fr_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier Evenement/Texte`)
};

const de_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis/Text kopieren`)
};

const it_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia evento/testo`)
};

const ru_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать событие/текст`)
};

const es_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento/texto`)
};

const zh_cn2_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制事件/文本`)
};

const ja_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント/テキストをコピー`)
};

const hi_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट/टेक्स्ट कॉपी करें`)
};

const pt_pt2_copy_title = /** @type {(inputs: Copy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento/texto`)
};

/**
* | output |
* | --- |
* | "Copy Event/Text" |
*
* @param {Copy_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_title = /** @type {((inputs?: Copy_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_title(inputs)
	if (locale === "de") return de_copy_title(inputs)
	if (locale === "it") return it_copy_title(inputs)
	if (locale === "ru") return ru_copy_title(inputs)
	if (locale === "es") return es_copy_title(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_title(inputs)
	if (locale === "ja") return ja_copy_title(inputs)
	if (locale === "hi") return hi_copy_title(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_title(inputs)
	return en_copy_title(inputs)
});